import React from 'react';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterToggleProps {
  value: string;
  onChange: (value: any) => void;
  options: FilterOption[];
}

const FilterToggle: React.FC<FilterToggleProps> = ({ value, onChange, options }) => {
  return (
    <div className="filter-toggle">
      <span className="filter-label">Show:</span>
      <div className="filter-buttons">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`filter-button ${value === option.value ? 'active' : ''}`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterToggle;